import { render, staticRenderFns } from "./Valoracion.vue?vue&type=template&id=2ba0c00a&"
import script from "./Valoracion.vue?vue&type=script&lang=js&"
export * from "./Valoracion.vue?vue&type=script&lang=js&"
import style0 from "./Valoracion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports